import { Form } from 'react-bootstrap';
import './singleCheckbox.scss';
import { connect } from 'react-redux';
import _ from 'lodash';

const SingleCheckbox = (props) => {

    let checkboxClasses = 'single-checkbox';
    if(props.entry.className) {
        checkboxClasses += ' ' + props.entry.className;
    }

    let defaultValue = _.get(props.stateData, props.entry.mapTo) || false;


    let myChangeHandler = (event) => {
        let mapTo = event.target.name;
        let val = event.target.checked;
        props.onChangeHandler(mapTo, val);
    };
    return (
        <Form.Group style={props.entry.style} className={checkboxClasses}>
            <Form.Check
                name={props.entry.mapTo}
                inline={props.entry.inline}
                label={props.entry.label}
                type="checkbox"
                id={`singlecheckbox-${props.entry.mapTo}`}
                key={`singlecheckbox-${props.entry.mapTo}`}
                checked={defaultValue}
                onChange={myChangeHandler}
            />
        </Form.Group>
    );
};


const mapStateToProps = function(state) {
    return {
      stateData : state.pagesData.data.basicInformation
    };
  };
  
export default connect(mapStateToProps)(SingleCheckbox);
